<template>
  <ul class="picture-list">
    <li class="picture-list__header picture-list__header-fb">
      <img src="../images/fb.png" width="40px" height="40px">
    </li>
    <template v-if="!reqPending">
      <li
        v-for="(item, key) in dataCollection"
        :key="key"
        class="picture-list__item"
        @click="showModal($event, item)"
        :style="`background-image: linear-gradient(0deg, ${social.colors[key]}, ${social.colors[key]})`"
      >
        <span class="picture-list__item-title">{{sliceAuthor(item.author)}}</span>

        <p class="picture-list__item-description" v-html="sliceText(item.text)">
        </p>

        <div class="picture-list__item-footer">
          <ul class="activity-list">
            <li class="activity-list__item activity-list__item-view">
              <img
                src="../images/eye-icon.png"
                class="activity-list__item-icon-view"
              >
              {{item.viewed}}
            </li>
            <li class="activity-list__item activity-list__item-like">
              <img
                src="../images/like-icon.png"
                class="activity-list__item-icon-like"
              >
              {{item.likes}}
            </li>
            <li class="activity-list__item activity-list__item-comment">
              <img
                src="../images/comment-icon.png"
                class="activity-list__item-icon-comment"
              >
              {{item.comments}}
            </li>
            <li class="activity-list__item activity-list__item-repost">
              <img
                src="../images/repost-icon.png"
                class="activity-list__item-icon-repost"
              >
              {{item.reposts}}
            </li>
          </ul>

          <span class="date-time">{{toDate(item.created_date)}}</span>
        </div>
      </li>
    </template>
    <table-preloader v-else></table-preloader>
  </ul>
</template>

<script>
// mixins
import pictureMixin from '../mixins';

// components
import TablePreloader from '@/components/preLoaders/tablePreloader.vue';

export default {
  name: 'Fb',
  data() {
    return {
      social: {
        name: 'fb',
        id: 3,
        colors: [
          '#3b5998',
          '#4f6aa2',
          '#627aad',
          '#768bb7',
          '#899bc1',
        ],
      },
      dataCollection: [],
      postCount: 5,
    };
  },
  methods: {
    showModal(event, post){
      const target = event.target;
      this.$root.$emit('togglePostToModal', {target, post});
    }
  },
  components: {
    TablePreloader,
  },
  mixins: [
    pictureMixin,
  ],
};
</script>

<style scoped>
  @import "../css/style.css";
  .picture-list__header-fb {
    display: flex;
    align-items: center;
    width: 350px;
    background-color: #3b5998;
    box-sizing: border-box;
  }

  @media (max-width: 1365px) {

    .picture-list__header-fb,
    .picture-list__item {
      width: 100%;
    }

  }

  @media (max-width: 1040px) {

    .picture-list__header-fb,
    .picture-list__item {
      width: 253px;
    }

  }

  @media (max-width: 760px) {
    .picture-list__header-fb,
    .picture-list__item {
      width: 100%;
    }
  }

</style>
